<template>
  <page-view>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询类型">
                <a-select v-model="queryParam.search_condition" placeholder="请选择查询类型" allowClear>
                  <a-select-option value="1">微信ID</a-select-option>
                  <a-select-option value="2">微信昵称</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="关键字">
                <a-input v-model="queryParam.keywords" placeholder="请先选择查询类型" />
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- <div class="table-operator">
        <a-button type="primary" @click="handleAddTaoshopblacklist">提交店铺黑名单</a-button>
      </div> -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 1000 }"
      >
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <!-- <span slot="avatar" slot-scope="text, record">
          <a-avatar shape="square" icon="user" :src="record.snapshot | getJsonKey('avatar')" />
        </span> -->
        <!-- <span slot="store_name" slot-scope="text, record">
          <a v-if="!record.snapshot">无</a>
          <span v-else>{{record.snapshot | getJsonKey('store_name')}}</span>
        </span> -->
        <span slot="type" slot-scope="text, record">
          <a-tag color="red">{{record.type | type}}</a-tag>
        </span>
        <span slot="source" slot-scope="text, record">
          <span v-if="record.source==1">NCNK官方</span>
          <span v-else>其他平台</span>
        </span>
        <!-- <span slot="reg_date" slot-scope="text, record">
          <a v-if="!record.snapshot">无</a>
          <span v-else>{{record.snapshot | getJsonKey('regtime')}}</span>
        </span> -->
        <span slot="create_time" slot-scope="text, record">
          <span>{{ record.create_time }}</span>
        </span>
        <template slot="action" slot-scope="text, record">
          <a @click="handleDelete([record.id])">移除黑名单</a>
        </template>
      </s-table>
    </a-card>
    <!-- <add-taoshopblacklist-modal ref="addTaoshopblacklistModal" @ok="$refs.table.refresh()"></add-taoshopblacklist-modal> -->
  </page-view>
</template>

<script>
import { STable } from '@/components'
import OrderApi from '@/api/order-new'
import { PageView } from '@/layouts'
import { mapActions, mapMutations } from 'vuex'
// import AddTaoshopblacklistModal from './modules/AddTaoshopblacklistModal'
const statusMap = {}

export default {
  name: 'CharacteristicTaoshopblacklist',
  components: {
    PageView,
    STable,
    // AddTaoshopblacklistModal
  },
  data() {
    return {
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {}, 
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: 60
        },
        {
          title: '店铺名称',
          dataIndex: 'store_name',
          //scopedSlots: { customRender: 'store_name' },
          width: 200
        },
        {
          title: '店铺旺旺',
          dataIndex: 'seller_nick',
          width: 200
        },
        {
          title: '账户ID',
          dataIndex: 'sub_id',
          width: 80
        },
         {
          title: '来源',
          dataIndex: 'source',
          scopedSlots: { customRender: 'source' },
          width: 130
        },
        {
          title: '类型',
          scopedSlots: { customRender: 'type' },
          width: 100
        },
        {
          title: '加入黑名单时间',
          scopedSlots: { customRender: 'create_time' },
          width: 220,
          sorter: true
        },
        {
          title: '操作',
          width: '120px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return OrderApi.getBlackList(Object.assign(parameter, this.queryParam))
      }
    }
  },
  filters: {
    getJsonKey(str, key) {
      const obj = str ? JSON.parse(str) : {}
      return obj[key] ? obj[key] : null
    },
    type(key) {
      if (key == 1) {
        return '未知'
      } else if (key == 2) {
        return '店淘店铺'
      } else if (key == 3) {
        return '短信偷粉'
      } else if (key == 4) {
        return '快递卡片偷粉'
      } else if (key == 5) {
        return '店铺群偷粉'
      } else if (key == 6) {
        return '其他'
      } else {
        return '其他'
      }
    }
  },
  computed: {},
  created() {},
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleDelete(ids) {
      let loading = this.$message.loading('正在移除')
      OrderApi.deleteBlackUser({ ids })
        .then(res => {
          if (res.code === 1) {
            this.$message.success('移除成功')
            this.$refs.table.refresh()
          } else {
            setTimeout(() => {
              this.$message.error(res.msg)
            }, 100)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },
    // handleAddTaoshopblacklist() {
    //   this.$refs.addTaoshopblacklistModal.show()
    // }
  }
}
</script>
<style lang="less" scoped>
// /deep/ .ant-badge-status-dot{
//     width: 10px;
//     height: 10px;
// }
</style>
